import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { CreateFlexPoolExternalPayload } from 'ogp/services/flex-pool-service.types';
import { workersPoolsService } from 'ogp/services';

type FlexPoolExternalMutationOptions = UseMutationOptions<
  unknown,
  unknown,
  CreateFlexPoolExternalPayload
>;

export const useCreateFlexPoolExternal = (options?: FlexPoolExternalMutationOptions) => {
  const mutationFn = async (payload: CreateFlexPoolExternalPayload) =>
    workersPoolsService.createWorkersPool({
      name: payload.name,
      description: payload.description,
      serviceAgreementIds: payload.serviceAgreementIds,
    });

  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};
  const mutationOptions: FlexPoolExternalMutationOptions = {
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(QUERY_KEYS.flexPools());
      onSuccess && onSuccess(data, variables, context);
    },
    ...restOptions,
  };

  return useMutation(mutationFn, mutationOptions);
};
